/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useSelector } from "react-redux";
import Select from 'react-select';
import { getEyesFilter, getEyesFilterById } from '../redux/FiltersSelector';
import { colourStylesSelect, themeSelect } from '../helpers';

interface Props {
  applyFilter: (data: any) => void;
  initialValues: any;
}

export const EyeFilter: React.FC<Props> = ({applyFilter, initialValues}) => {
  const eyesChoices: Array<any> = useSelector(getEyesFilter) as Array<any>;
  const initialEyesValues: any = useSelector(getEyesFilterById(initialValues)) as any;
  const [optionsSelect, setOptionsSelect] = React.useState(initialEyesValues[0])

  return (
    <div className='col-lg-4'>
      <h4>Color de ojos</h4>
      <Select
        styles={colourStylesSelect}
        theme={themeSelect}
        options={eyesChoices}
        placeholder="Seleccionar color de ojos"
        defaultValue={optionsSelect}
        value={optionsSelect}
        isClearable={true}
        isMulti={false}
        onChange={(option) => {
          if (option) {
            setOptionsSelect({...option});
            // FILTRAR
            const eyeToSend = option.value
            if (eyeToSend) {
              applyFilter({eye: eyeToSend})
            }
            
          } else {
            setOptionsSelect(null);
            applyFilter({eye: null})
          }
        }}
      />
    </div>
  )
}

export default EyeFilter;
